import { Navigate } from "react-router-dom";
import { urls } from "../../urls";
import { useSub } from "../subscription/useSub";
import { AssistantChat } from "./AssistantChat";

export const AssistantPage = () => {
  const { hasAssistantAccess } = useSub();
  // Feature-flagged off by default; hide the page entirely for orgs without access.
  if (!hasAssistantAccess) {
    return <Navigate to={urls.app.home} replace />;
  }
  return <AssistantChat />;
};
